import { Store } from './Store';
import { IdbStore } from './idbStore';
import { SupabaseStore } from './supabaseStore';
import { supabase } from '../lib/supabase';

let storeInstance: Store | null = null;

export async function getStore(): Promise<Store> {
  if (storeInstance) {
    return storeInstance;
  }

  // Check if user is authenticated
  const { data: { session } } = await supabase.auth.getSession();
  
  // Use Supabase store if authenticated, otherwise use IndexedDB
  storeInstance = session?.user 
    ? new SupabaseStore(session.user.id)
    : new IdbStore();

  return storeInstance;
}

// Helper to check if cloud sync is available
export async function isCloudEnabled(): Promise<boolean> {
  const { data: { session } } = await supabase.auth.getSession();
  return !!session?.user;
} 